// TODO: Delete this file

import io from 'socket.io-client'

const state = {
  announcementSocket: null,
  announcementNode: null
}

const getters = {
  announcementSocket (state) {
    return state.announcementSocket
  },
  announcementNode (state) {
    return state.announcementNode
  }
}

const mutations = {
  SET_ANNOUNCEMENT_SOCKET (state, announcementSocket) {
    // Check if already has value.
    if (state.announcementSocket === null) {
      state.announcementSocket = announcementSocket
    }
  },
  SET_ANNOUNCEMENT_NODE (state, announcementNode) {
    // Check if already has value.
    if (state.announcementNode === null) {
      state.announcementNode = announcementNode
    }
  }
}

const actions = {
  setAnnouncementSocket ({ commit }, announcementSocket) {
    commit('SET_ANNOUNCEMENT_SOCKET', announcementSocket)
  },
  setAnnouncementNode ({ commit, dispatch, getters }, announcementNode) {
    commit('SET_ANNOUNCEMENT_NODE', announcementNode)

    if (getters.announcementNode !== null) {
      const socket = io.connect(`${getters.announcementNode.domain}:${getters.announcementNode.port}/${getters.announcementNode.namespace}`, { transports: ['websocket'] })
      dispatch('setAnnouncementSocket', socket)
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
